<template>
  <div class="pending list-box">
    <div class="tree">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>

    <div class="right-box">
      <TableSearch
        :search-config="searchConfig"
        :search-params="searchParams"
        @resetCallBack="reset()"
        @search="search"
      ></TableSearch>
      <Table
        :tabelButtons="tabelButtons"
        :pagination="pagination"
        :table-config="tableConfig"
        :template-data="tableData"
      ></Table>
    </div>

    <el-dialog
      class="info-box"
      title="报警详情"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <AlarmDetailBox :alarm-detail-data="alarmInfo"></AlarmDetailBox>
    </el-dialog>
  </div>
</template>

<script>
import AlarmDetailBox from "../alarm-detail-box/alarm-detail-box";
import Tree from "@/components/Tree/nodeTree";
import { listAPI, mapAPI } from "@/api-path/command-center.js";
const alarmTypes = [
  {
    label: "一键报警",
    value: "1",
  },
  {
    label: "图文报警",
    value: "2",
  },
  {
    label: "终端报警",
    value: "3",
  },
  {
    label: "110报警",
    value: "4",
  },
  {
    label: "120报警",
    value: "5",
  },
  {
    label: "119报警",
    value: "6",
  },
  {
    label: "第三方报警",
    value: "7",
  },
];
export default {
  name: "pending",
  components: {
    Tree,
    AlarmDetailBox,
  },
  data() {
    return {
      dialogVisible: false,
      switchVal: false,
      isDown: false, // 是否查询下级
      searchConfig: {
        items: [
          {
            valueType: "select",
            placeholder: "请选择报警方式",
            key: "alarmType",
            data: alarmTypes,
          },
          {
            placeholder: "关键词搜索",
            key: "search",
          },
          {
            placeholder: "开始时间:结束时间",
            valueType: "datetimerange",
            key: "date",
          },
        ],
      },
      searchParams: {
        search: "",
        alarmGrade: "", // 紧急程度
        areaId: "", // 区域ID
        status: "1", // 事件状态
        alarmType: "", // 报警方式
        userId: sessionStorage.getItem("userId"), // 用户Id
        date: [],
        page: 1,
        size: 15,
      },
      tabelButtons: [],
      tableConfig: {
        rows: [
          {
            label: "报警时间",
            prop: "happenDate",
          },
          {
            label: "报警人",
            prop: "userName",
          },
          {
            label: "区域",
            prop: "areaName",
          },
          {
            label: "接警中心",
            prop: "centerName",
          },
          {
            label: "报警来源",
            prop: "sourceName",
          },
          {
            label: "报警方式",
            prop: "alarmType",
          },
          {
            label: "内容",
            prop: "content",
          },
          {
            label: "报警地点",
            prop: "address",
            // width: '100px',
            type: "popover",
          },
          {
            label: "状态",
            prop: "statusName",
          },
        ],
        rowButtons: {
          width: "180px",
          items: [
            {
              label: "处理",
              fn: (data) => {
                this.$http
                  .post(mapAPI.addClues, {
                    handleType: 4,
                    alarmId: data.id,
                    fileDTOList: [],
                  })
                  .then((res) => {
                    if (res.status === 200) {
                      this.goDetail(data);
                    } else if (res.status === 418) {
                      //刷新红点,刷新列表
                      this.caseRed();
                      this.search();
                    }
                  });
              },
            },
            {
              label: "查看",
              color: "#80CBF3",
              fn: this.getAlarmDetail,
            },
          ],
        },
      },
      tableData: [],
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: (size) => {
          this.pagination.size = size;
          this.searchParams.size = size;
          this.search();
        },
        pageChange: (page) => {
          this.pagination.page = page;
          this.searchParams.page = page;
          this.search();
        },
      },
      alarmInfo: {},
    };
  },
  computed: {
    newAlarm() {
      return this.$store.state.hasNewAlarm; //新的报警
    },
  },
  watch: {
    newAlarm(newVal, oldVal) {
      if (newVal) {
        this.search();
      }
    },
  },
  methods: {
    caseRed() {
      this.$http.get(listAPI.caseRed).then((res) => {
        if (res.status === 200) {
          let value = res.result.TOBEPROCESSED >= 99 ? "99+" : res.result.TOBEPROCESSED;
          let value1 = res.result.PROCESSING >= 99 ? "99+" : res.result.PROCESSING;
          this.$store.commit("setAlarmCount", {
            name: "pendingCount",
            value,
          });
          this.$store.commit("setAlarmCount", {
            name: "processingCount",
            value: value1,
          });
        }
      });
    },
    search() {
      const { date, ...params } = { ...this.searchParams };
      params.startTime = date[0];
      params.endTime = date[1];
      params.isDown = this.isDown;
      this.$http
        .get(listAPI.list, {
          params,
        })
        .then((res) => {
          res.result.pageList.map((item) => {
            item.alarmSource = this.matchFn.matchCodeName(
              "ALARM_SOURCE",
              item.alarmSource
            );
            item.alarmType = this.matchFn.matchCodeName("ALARM_TYPE", item.alarmType);
          });
          this.pagination.total = res.result.total;
          this.tableData = res.result.pageList;
          this.$store.commit("setHasNewAlarm", false);
        });
    },

    getAlarmDetail(data) {
      this.$http.get(listAPI.datail + "?alarmId=" + data.id).then((res) => {
        this.dialogVisible = true;
        res.result.handlers.map((item) => {
          item.isOpen = false;
        });
        this.alarmInfo = res.result;
      });
    },
    goDetail(data) {
      this.$http.get(listAPI.datail + "?alarmId=" + data.id).then((res) => {
        if (res.status == 200) {
          if (res.result.status == 9) {
            this.$message.error("该报警已取消！");
            this.search();
            $this.$store.commit("setAlarmCount", {
              type: "",
              name: "pendingCount",
            });
          } else {
            localStorage.setItem("eventUserId", data.userId);
            sessionStorage.setItem("groupId", data.id);
            this.$store.commit("setAlarmId", data.id);
            sessionStorage.setItem("alarmInfo", JSON.stringify(res.result));
            this.$router.push({ path: "/command/map" });
          }
        }
      });
    },
    changeSwitch(node) {
      this.isDown = node;
      this.searchParams.page = 1;
      this.search();
    },

    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.areaId = node.id;
      this.search();
    },
    reset() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.searchParams.areaId = this.areaId;
      this.searchParams.userId = sessionStorage.getItem("userId");
      this.searchParams.status = "1";
      this.searchParams.alarmGrade = "";
      this.searchParams.search = "";
      this.searchParams.alarmType = "";
      this.searchParams.date = [];
      this.search();
    },
    analysis(inx) {
      if (inx == 1) {
        return "发起";
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "pending";
</style>
